<template>
  <MyClosetSectionPreview>
    <template #headline="{section}">
      <SectionHeadline :title="section.name.value"/>
    </template>
    <template #name="{section}">
      {{ section.subtitle.value }}
    </template>
  </MyClosetSectionPreview>
</template>

<script setup>
import MyClosetSectionPreview from '@/components/closet/MyClosetSectionPreview.vue'
import SectionHeadline from '@/components/global/SectionHeadline.vue'

</script>
